exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3UksEevI6J4T3jkrs0_aCE {\n  position: relative;\n}\n._2nn2GhMyzXD7qzvef-XGV0 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: borderRadius;\n  background-color: rgba(0,0,0,.3);\n}\n.interpretationItems-enter {\n  opacity: 0.01;\n  max-height: 0;\n}\n\n.interpretationItems-enter.interpretationItems-enter-active {\n  opacity: 1;\n  max-height: 300px;\n  -webkit-transition: all 0.5s ease-out;\n  -o-transition: all 0.5s ease-out;\n  transition: all 0.5s ease-out;\n}\n", ""]);

// exports
exports.locals = {
	"interpretations": "_3UksEevI6J4T3jkrs0_aCE",
	"loading": "_2nn2GhMyzXD7qzvef-XGV0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/IDTFRecordingInfoPane/Interpretations/Interpretations.css
// module id = 9431
// module chunks = 23